export enum ReportDataFunction
{
    Sum,
    Min,
    Max,
    Average,
    Median,
    Range,
    Count,
    First,
    Last,
    List,
    Percent
}
